module.exports = __webpack_public_path__ + "static/media/How to create deposit invoices and a deposit receipt using the templated invoice.05f568a4.png";